import React from 'react'
import PropTypes from 'prop-types'
import componentObj from './dataset'

const Header = ({ selected }) => {
  const { title, description } = componentObj.find(({ value }) => value === selected)

  return (
    <div className="flex items-center justify-between mx-5">
      <div className="flex-1">
        <h1 className="text-3xl text-primary-black">{title}</h1>
        <p className="text-dim-gray">{description}</p>
      </div>
    </div>
  )
}

Header.propTypes = {
  selected: PropTypes.string,
}

export default Header
